import { RendererContextType } from '../../../../contexts/RendererContext';
import { ProjectByIdQuery } from '../../../../types/graphqlTypes';
import { PointoramaOpeningSketch } from '../../../../potree/utils/PointoramaOpeningSketch';
import { resolveFloorGroupIdentifier } from '../../../../utils/roomFolders';
import { SyncConfig } from './syncFromGraphQL';

type Project = ProjectByIdQuery['projectById'];
type Annotation = Project['state']['annotations'][number];
type Group = Project['state']['groups'][number];

export function createSyncOpeningSketchesConfig({ viewer, annotations, groups }: { viewer: NonNullable<RendererContextType['viewer']>; annotations: Annotation[]; groups: Group[] }): SyncConfig<Annotation, PointoramaOpeningSketch> {
  return {
    getSourceItems: () => annotations.filter((a) => a.type === 'OPENING_SKETCH'),
    getSceneItems: () => [...(viewer.scene.openingSketches || [])],
    getSourceIdentifier: (item) => item.identifier,
    getSceneIdentifier: (item) => item.identifier,
    // update() omitted — geometry/glyph updates are handled by reactive property
    // subscriptions on the scene object (and the owning wall sketch's glyph pass).
    create: (source) => {
      const openingSketch = new PointoramaOpeningSketch(viewer);
      openingSketch.identifier = source.identifier;
      // The scene object's groupIdentifier is the FLOOR membership marker used
      // by the wall sketch's glyph/cutter filters — resolve through a room
      // folder's parent.
      openingSketch.groupIdentifier = resolveFloorGroupIdentifier(groups, source.groupIdentifier);
      openingSketch.finished = true;
      return openingSketch;
    },
    addToScene: (item) => viewer.scene.addOpeningSketch(item),
    removeFromScene: (item) => viewer.scene.removeOpeningSketch(item),
  };
}
